export default "__VITE_ASSET__D2pwABel__"